import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '../../SelectBox';
import WizardInput from '../Input';

const CourseTypeSelector = ({
  categories,
  onChange,
  name,
  value,
  disabled,
  t,
  category,
  locale,
}) => (
  <WizardInput title={t('course.create.wizard.step2_2')} hint={t('wizard.hint.coursetype')}>
    <SelectBox
      disabled={disabled}
      value={value || t}
      label={t('category')}
      name={name}
      onChange={onChange}
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      placeholder={t('course.edit.subcategory.placeholder')}
      options={
        category &&
        categories
          .filter(ct => ct.category && ct.category === category.id)
          .map(option => ({
            id: option[`title_${locale}`] || option.title,
            value: option[`title_${locale}`] || option.title,
          }))
      }
    />
  </WizardInput>
);

CourseTypeSelector.propTypes = {
  category: PropTypes.object,
  disabled: PropTypes.bool,
  categories: PropTypes.array,
  value: PropTypes.string,
  name: PropTypes.string,
  t: PropTypes.func,
  onChange: PropTypes.func,
  locale: PropTypes.string,
};

CourseTypeSelector.defaultProps = {
  category: {},
  disabled: false,
  categories: [],
  value: '',
  name: '',
  t: () => {},
  onChange: () => {},
  locale: '',
};

export default CourseTypeSelector;
